import { createGlobalStyle } from "styled-components"

 const GlobalStyle = createGlobalStyle`
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Uchen', serif;
}



// body {
// 	background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
// 	background-size: 300% 400%;
// 	animation: gradient 20s ease infinite;
// 	height: 100vh;
	

// @keyframes gradient {
// 	0% {
// 		background-position: 0% 50%;
// 	}
// 	50% {
// 		background-position: 100% 50%;
// 	}
// 	100% {
// 		background-position: 0% 50%;
// 	}
// }


    `;
export default GlobalStyle